import { useState } from 'react';
import { Card, flip, Image, offset, shift, Spacing, useFloating } from '@vinted/web-ui';
import classNames from 'classnames';
import OutsideClick from 'components/OutsideClick';
import ScrollableArea from 'components/ScrollableArea';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const UserMenuDropdown = _ref => {
  let {
    userName,
    userPhoto,
    children
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);

  const handleMenuButtonClick = () => setIsOpen(prevIsOpen => !prevIsOpen);

  const handleOutsideClick = () => setIsOpen(false);

  const {
    floaterRef,
    triggerRef,
    floaterStyle
  } = useFloating({
    middleware: [offset(Spacing.Medium), flip({
      mainAxis: false
    }), shift()],
    placement: 'bottom-end',
    shouldAutoUpdate: true,
    isFloaterVisible: isOpen
  });
  return /*#__PURE__*/_jsxs(OutsideClick, {
    onOutsideClick: handleOutsideClick,
    children: [/*#__PURE__*/_jsx("div", {
      id: "user-menu-button",
      role: "button",
      tabIndex: 0,
      ref: triggerRef,
      onClick: handleMenuButtonClick,
      className: classNames({
        open: isOpen
      }),
      children: /*#__PURE__*/_jsx("figure", {
        className: "photo-centered-parent header-avatar u-cursor-pointer",
        children: /*#__PURE__*/_jsx(Image, {
          src: userPhoto,
          alt: userName,
          styling: Image.Styling.Circle
        })
      })
    }), isOpen && /*#__PURE__*/_jsx("div", {
      ref: floaterRef,
      style: floaterStyle,
      children: /*#__PURE__*/_jsx(Card, {
        styling: Card.Styling.Elevated,
        children: /*#__PURE__*/_jsx(ScrollableArea, {
          children: /*#__PURE__*/_jsx("div", {
            className: "user-menu-groups",
            children: children
          })
        })
      })
    })]
  });
};

export default UserMenuDropdown;